export class PromiseCompletionSource<TResult> {
    private readonly promise: Promise<TResult>;
    private resolver: (result: TResult) => void;
    private rejecter: (reason: any) => void;
	
    public get result(): Promise<TResult> {
        return this.promise;
    }

    public constructor() {
        this.promise = new Promise((resolve, reject) => {
            this.resolver = resolve;
            this.rejecter = reject;
        });
    }

    public complete(result: TResult): void {
        this.resolver(result);
    }

    public error(reason: any): void {
        this.rejecter(reason);
    }
}